import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLivePlayersReportStart } from '../../../../store/redux-slices/dashboard'

const useLivePlayers = ({ selectedPortal, selectedClient }) => {
  const dispatch = useDispatch()
  const { livePlayerloading: loading, livePlayerData } = useSelector((state) => state.dashboard)
  const [count, setCount] = useState(0)
  const { adminPermissions } = useSelector(state => state.admins)
  const permissionKeys = adminPermissions && Object.keys(adminPermissions)

  const fetchDetails = () => {
    dispatch(getLivePlayersReportStart({
      isTenant: false,
      tenantId: selectedPortal,
      adminId: selectedClient
    }))
  }

  useEffect(() => {
    fetchDetails();
    setInterval(fetchDetails, 3600000); // for 1 hr
  }, [selectedPortal, selectedClient])

  // useEffect(() => {
  //   if (permissionKeys.includes('LivePlayerReport')) {
  //     const intervals = setInterval(() => {
  //       clearInterval(intervals)
  //       fetchDetails()
  //       setCount(count + 1)
  //     }, 3000)
  //   }
  // }, [count])

  return {
    loading,
    livePlayerData,
    fetchDetails
  }
}

export default useLivePlayers
